// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59fb7b57","970":"145dec2c"}[chunkId] + ".chunk.js";
};